/**
 * Theme Exports
 *
 * Central export for all available themes.
 */

export * from './types';
export * from './fonts';
export { defaultTheme } from './default.theme';
export { basecampTheme } from './basecamp.theme';
export { oceanTheme } from './ocean.theme';
export { forestTheme } from './forest.theme';
export { sunsetTheme } from './sunset.theme';
export { slateTheme } from './slate.theme';
export { roseTheme } from './rose.theme';
export { lavenderTheme } from './lavender.theme';
export { clarityTheme } from './clarity.theme';
export { blueprintTheme } from './blueprint.theme';

import { defaultTheme } from './default.theme';
import { basecampTheme } from './basecamp.theme';
import { oceanTheme } from './ocean.theme';
import { forestTheme } from './forest.theme';
import { sunsetTheme } from './sunset.theme';
import { slateTheme } from './slate.theme';
import { roseTheme } from './rose.theme';
import { lavenderTheme } from './lavender.theme';
import { clarityTheme } from './clarity.theme';
import { blueprintTheme } from './blueprint.theme';
import type { AppTheme, ThemeName } from './types';

/**
 * All available themes
 */
export const themes: Record<ThemeName, AppTheme> = {
  default: defaultTheme,
  basecamp: basecampTheme,
  ocean: oceanTheme,
  forest: forestTheme,
  sunset: sunsetTheme,
  slate: slateTheme,
  rose: roseTheme,
  lavender: lavenderTheme,
  clarity: clarityTheme,
  blueprint: blueprintTheme,
};

/**
 * Get theme by name
 */
export const getTheme = (name: ThemeName): AppTheme => {
  return themes[name] || defaultTheme;
};

/**
 * Get all theme names
 */
export const getThemeNames = (): ThemeName[] => {
  return Object.keys(themes) as ThemeName[];
};

/**
 * Get all themes as array
 */
export const getThemes = (): AppTheme[] => {
  return Object.values(themes);
};
